exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-message[data-v-6d1e4fda]{vertical-align:text-bottom}.title[data-v-6d1e4fda]{min-height:40px;display:flex;align-items:center;font-weight:700}.feedback-optional-actions .btn[data-v-6d1e4fda]{min-width:170px}", ""]);

// exports
